'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDownload = function TiDownload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.8 12.3c-0.3-0.3-0.7-0.4-1.1-0.4s-0.9 0.1-1.2 0.4l-3.8 3.9v-11.2c0-0.9-0.8-1.7-1.7-1.7s-1.7 0.8-1.7 1.7v11.2l-3.8-3.9c-0.3-0.3-0.7-0.4-1.2-0.4s-0.8 0.1-1.1 0.4c-0.7 0.7-0.7 1.7 0 2.4l7.8 7.8 7.8-7.8c0.7-0.7 0.7-1.7 0-2.4z m7.2 14.4c0-0.2 0-0.4-0.1-0.6l-3.3-10c-0.2-0.6-0.9-1.1-1.6-1.1h-0.4c-0.1 0.3-0.3 0.6-0.6 0.9l-2.4 2.4h2.2l2.8 8.4h-23.2l2.8-8.4h2.2l-2.4-2.4c-0.3-0.3-0.5-0.6-0.6-0.9h-0.4c-0.7 0-1.4 0.5-1.6 1.1l-3.3 10c-0.1 0.2-0.1 0.4-0.1 0.6 0 0 0 8.3 0 8.3 0 0.9 0.7 1.7 1.7 1.7h26.6c1 0 1.7-0.8 1.7-1.7 0 0 0-8.3 0-8.3z' })
        )
    );
};

exports.default = TiDownload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/download.js
// module id = 3613
// module chunks = 0